export default "__VITE_ASSET__I9wYzmQM__"